import React, { useState, useEffect } from 'react';
import '../styles/CountdownTimer.css';

const CountdownTimer = ({ targetDate }) => {
  const [timeLeft, setTimeLeft] = useState({
    days: 0,
    hours: 0,
    minutes: 0,
    seconds: 0
  });

  useEffect(() => {
    const calculateTimeLeft = () => {
      const difference = new Date(targetDate) - new Date();
      
      if (difference > 0) {
        setTimeLeft({
          days: Math.floor(difference / (1000 * 60 * 60 * 24)),
          hours: Math.floor((difference / (1000 * 60 * 60)) % 24),
          minutes: Math.floor((difference / 1000 / 60) % 60),
          seconds: Math.floor((difference / 1000) % 60)
        });
      }
    };

    calculateTimeLeft();
    const timer = setInterval(calculateTimeLeft, 1000);

    return () => clearInterval(timer);
  }, [targetDate]);

  return (
    <div className="countdown-timer">
      <div className="timer-unit">
        <div className="timer-value">{timeLeft.days}</div>
        <div className="timer-label">Days</div>
      </div>
      <div className="timer-separator">:</div>
      <div className="timer-unit">
        <div className="timer-value">{timeLeft.hours}</div>
        <div className="timer-label">Hours</div>
      </div>
      <div className="timer-separator">:</div>
      <div className="timer-unit">
        <div className="timer-value">{timeLeft.minutes}</div>
        <div className="timer-label">Minutes</div>
      </div>
      <div className="timer-separator">:</div>
      <div className="timer-unit">
        <div className="timer-value">{timeLeft.seconds}</div>
        <div className="timer-label">Seconds</div>
      </div>
    </div>
  );
};

export default CountdownTimer;